import { makeStyles } from '../../../styles';
export const useStyles = makeStyles((theme) => {
    const LINE_STYLE = {
        content: '""',
        position: 'relative',
        display: 'block',
        left: '50%',
        height: 20,
        width: 1,
        backgroundColor: theme.colors.gray[200],
    };
    return {
        root: (props) => ({
            marginLeft: props.leftOffset || 0,
        }),
        container: {
            display: 'inline-block',
            '&::before': Object.assign({}, LINE_STYLE),
            '&::after': Object.assign({}, LINE_STYLE),
        },
        textBox: Object.assign(Object.assign({}, theme.typography.subtitle1), { padding: '4px 15px', color: theme.colors.primary.main, borderRadius: 5, boxShadow: `0 1px 4px 0 ${theme.colors.gray[200]}` }),
    };
});
//# sourceMappingURL=VerticalJoiner.styles.js.map